import React from "react";

const ProgressSteps = ({ currentStep, totalSteps, stepTitles }) => {
  return (
    <div className="w-full mb-6">
      {/* Progress Bar */}
      <div className="flex items-center justify-between relative">
        {stepTitles.map((title, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber === currentStep;
          const isCompleted = stepNumber < currentStep;

          return (
            <React.Fragment key={stepNumber}>
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold transition-all duration-300 border-2 ${
                    isCompleted
                      ? "bg-brand-pink border-brand-pink text-white"
                      : isActive
                      ? "bg-brand-blue-dark border-brand-blue-dark text-white"
                      : "bg-white border-border text-muted-foreground"
                  }`}
                >
                  {isCompleted ? (
                    <svg
                      className="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  ) : (
                    stepNumber
                  )}
                </div>
                
                {/* Step Title */}
                <div className="mt-1.5 text-center">
                  <div
                    className={`text-xs font-medium ${
                      isActive
                        ? "text-brand-blue-dark"
                        : isCompleted
                        ? "text-brand-pink"
                        : "text-muted-foreground"
                    }`}
                  >
                    {stepTitles[index]}
                  </div>
                </div>
              </div>

              {/* Connector Line */}
              {stepNumber < totalSteps && (
                <div
                  className={`flex-1 h-0.5 mx-3 mt-[-16px] transition-all duration-300 rounded-full ${
                    stepNumber < currentStep ? "bg-brand-pink" : "bg-border"
                  }`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* Current Step Information */}
      <div className="mt-4 text-center">
        <h5 className="text-xl font-bold text-foreground">
          {stepTitles[currentStep - 1]}
        </h5>
        <p className="text-xs text-muted-foreground mt-0.5">
          Step {currentStep} of {totalSteps}
        </p>
      </div> 
    </div>
  );
};

export default ProgressSteps;
